import angular from 'angular';

import config from 'src/config';
import completeMenuImgUrl from 'assets/images/onboarding_complete_menu.jpg';

class WelcomeCtrl {
  constructor(venues, alertService, $sce, organizationService, sdkOrganizationService, $state, $window, $q, onboardingService, $timeout) {
    if (!venues || !venues.length) {
      this.noVenues = true;
      return;
    }

    this._$q = $q;
    this._alertService = alertService;
    this._$window = $window;
    this._$state = $state;
    this._sdkOrganizationService = sdkOrganizationService;
    this._organizationService = organizationService;
    this._onboardingService = onboardingService;
    this._$timeout = $timeout;

    this.completeMenuImgUrl = completeMenuImgUrl;

    this.currentOrganization = organizationService.getCurrentOrganization();
    this.currentOrganization.onboardingSteps = this.currentOrganization.onboardingSteps || {};

    this.helpCenterUrl = $sce.trustAsResourceUrl(config.HELP_CENTER_URL);
    this.stepsCompleted = function () {
      return onboardingService.getCurrentOrganizationStepsCompleted();
    };
    this.stepsRemaining = function () {
      return onboardingService.getCurrentOrganizationStepsRemaining();
    };
    this.onboardingCompleted = false;
    this.totalSteps = onboardingService.totalOnboardingSteps;
    this.steps = [{
      order: 1,
      complete: this.currentOrganization.onboardingSteps.setupBilling,
      apiProperty: 'setupBilling',
      completeOnClick: false,
      icon: 'ion-card',
      header: 'Add your credit card information',
      subText: `You have <strong>${onboardingService.getCurrentOrganizationTrialDaysLeft()}</strong> days left on your <strong>30 day trial</strong>. Enter your billing information to avoid disruption of your service.`, //eslint-disable-line
      btnPrimary: 'Add Credit Card',
      skipable: false,
      state: 'app.organization.settings.billing'
    }, {
      order: 2,
      complete: this.currentOrganization.onboardingSteps.setupVenue,
      apiProperty: 'setupVenue',
      completeOnClick: true,
      icon: 'fa fa-building-o',
      header: 'View and update your venue settings',
      subText: 'Update settings for your venue like business hours, address and contact information. You can also provide defaults for your events to save some time.',
      btnPrimary: 'Update Settings',
      skipable: true,
      state: 'app.organization.venueSettings.basicInfo',
      stateParams: {
        venueId: venues[0].id
      }
    }, {
      order: 3,
      complete: this.currentOrganization.onboardingSteps.setupTeam,
      apiProperty: 'setupTeam',
      completeOnClick: true,
      icon: 'ion-person-stalker',
      header: 'Invite your staff members and promoters',
      subText: 'Start adding your staff members and invite promoters to your venue. You can give out specific permissions to have fine grained control over what other users can see and do.',
      btnPrimary: 'Invite Team',
      skipable: true,
      state: 'app.organization.team.staff'
    }, {
      order: 4,
      complete: this.currentOrganization.onboardingSteps.setupMobileApps,
      apiProperty: 'setupMobileApps',
      completeOnClick: true,
      icon: 'icon-np-mobile-apps',
      header: 'Download mobile apps',
      subText: 'Take NightPro on the go with our mobile apps for iOS and Android. Have your promoters download the apps too so they can easily enter reservations and guestlists into your NightPro account.', //eslint-disable-line
      btnPrimary: 'Download Apps',
      skipable: true,
      externalLink: true,
      externalLinkUrl: 'https://itunes.apple.com/us/app/nightpro/id588113354?mt=8'
    }, {
      order: 5,
      complete: this.currentOrganization.onboardingSteps.setupFloorplans,
      apiProperty: 'setupFloorplans',
      completeOnClick: true,
      icon: 'ion-social-buffer',
      header: 'Setup floorplans and add tables',
      subText: 'Start adding tables to your floor plans so you can start taking reservations.',
      btnPrimary: 'Add Floorplans',
      skipable: true,
      state: 'app.organization.settings.venue.floorplans',
      stateParams: {
        venueId: venues[0].id
      }
    }, {
      order: 6,
      complete: this.currentOrganization.onboardingSteps.setupEvents,
      apiProperty: 'setupEvents',
      completeOnClick: true,
      icon: 'ion-calendar',
      header: 'Create your first event',
      subText: 'Setup recurring events, upload event flyers and more.',
      btnPrimary: 'Add Events',
      skipable: true,
      state: 'app.organization.createEvent',
      stateParams: {
        venueId: venues[0].id
      }
    }, {
      order: 7,
      complete: this.currentOrganization.onboardingSteps.setupReservations,
      apiProperty: 'setupReservations',
      completeOnClick: true,
      icon: 'icon-np-reservations',
      header: 'Start adding reservations & guestlist',
      subText: 'Once you have your floorplan setup with tables you can start taking reservations and guestlists.',
      btnPrimary: 'Add Reservation/Guestlist',
      skipable: true,
      state: 'app.organization.manage.reservations',
      stateParams: {
        venueId: venues[0].id
      }
    }, {
      order: 8,
      complete: this.currentOrganization.onboardingSteps.setupCRM,
      apiProperty: 'setupCRM',
      completeOnClick: true,
      icon: 'ion-chatboxes',
      header: 'Build out your Customer Database (CRM)',
      subText: 'As soon as you start adding reservations and guestlists NightPro will keep track of all your customers. Use the CRM to view customer profiles and see how much your customers are spending at your venue.', //eslint-disable-line
      btnPrimary: 'View CRM',
      skipable: true,
      state: 'app.organization.customerDatabase'
    }].map(step => {
      step.subText = $sce.trustAsHtml(step.subText);
      return step;
    });
  }

  goToStepComplete(step, $event) {
    if (!step || !step.complete) return null;

    return this.goToStep(step, false, $event);
  }

  goToStep(step, skip, $event) {
    if (!step) return;
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }

    let completePromise;

    if (step.completeOnClick && !step.complete) {
      completePromise = this._onboardingService.completeOnboardingStep(step.apiProperty);
    } else {
      completePromise = this._$q.resolve(null);
    }

    completePromise
      .then(updatedOrganization => {
        if (updatedOrganization) {
          angular.extend(this.currentOrganization, updatedOrganization);

          this._organizationService.setCurrentOrganization(updatedOrganization);
        }

        if (skip) {
          step.complete = true;

          if (this._onboardingService.isCurrentOrganizationOnboardingComplete()) {
            this.onboardingCompleted = true;
            this.showOnboardingCompletedHeaderIcon = true;

            this._$timeout(() => {
              this.showOnboardingCompletedHeader = true;
            }, 600);

            this._$timeout(() => {
              this.showOnboardingCompletedBody = true;
            }, 1200);
          }
        } else if (step.externalLink) {
          step.complete = true;

          this._$window.open(step.externalLinkUrl);
        } else {
          angular.extend(step.stateParams || {}, {
            organizationId: this.currentOrganization.id
          });

          this._$state.go(step.state, step.stateParams);
        }
      });
  }
}

WelcomeCtrl.$inject = [
  'venues',
  'alertService',
  '$sce',
  'organizationService',
  'jsSdk.organization',
  '$state',
  '$window',
  '$q',
  'onboardingService',
  '$timeout'
];

export default WelcomeCtrl;



// WEBPACK FOOTER //
// ./src/components/welcome/welcomeCtrl.js